import { Coordinates } from '../../modules/stores/types';

const SUCCESS_GEOCODING_STATUSES = ['OK'];

export class Geocoder {
  static isGeocoderAvailable() {
    if (typeof google === 'undefined') {
      return false;
    }

    // eslint-disable-next-line no-undef
    return Boolean(google?.maps?.Geocoder);
  }

  static getCoordinates(search: string): Promise<Coordinates | null> {
    return new Promise<Coordinates | null>((resolve, reject) => {
      try {
        // eslint-disable-next-line no-undef
        const gg = new google.maps.Geocoder();
        gg.geocode({ address: search }, (res, status) => {
          if (!SUCCESS_GEOCODING_STATUSES.includes(status) || !res?.[0]) {
            resolve(null);
          } else {
            resolve({
              lat: res[0].geometry.location.lat(),
              lng: res[0].geometry.location.lng(),
            });
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }
}
